module.exports = __webpack_public_path__ + "media/images/icons/SVG/004-801ee425ec95861d39bea48fb649e190.svg";